import { POST_REVIEW_VOTE_FAILURE, POST_REVIEW_VOTE_START, POST_REVIEW_VOTE_SUCCESS } from '../constants/types';
import { makeAsyncReducer } from '../utils/async_utils';

export const postReviewVote = makeAsyncReducer(
  { startType: POST_REVIEW_VOTE_START, successType: POST_REVIEW_VOTE_SUCCESS, failureType: POST_REVIEW_VOTE_FAILURE },
  { initialData: {} }
);

export const postReviewVoteSelector = (state) => state.ratingReviews.postReviewVote;
